<template>
  <v-row class="home-page pl-5 pr-5">
    <v-col cols="12" align="center"></v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import actionTypes from "@/vuex/action-types";
import * as utils from "@/common/utils";

export default {
  name: "Home",
  computed: {
    ...mapGetters(["profileLoaded", "profileScopes"])
  },
  watch: {
    profileScopes: {
      immediate: true,
      handler(newVal) {
        const afterLoginRedirect = utils.getCookie("after_login_redirect");
        if (afterLoginRedirect != "") {
          utils.setCookie("after_login_redirect", "", 0);
          window.location.href = afterLoginRedirect;
        } else {
          if (newVal.length > 0) {
            if (newVal.includes("*") || newVal.includes("erp")) {
              window.location.href = process.env.VUE_APP_ENV_ERP_URL;
            } else {
              window.location.href = process.env.VUE_APP_ENV_DQ_URL;
            }
          }
        }
      }
    }
  },
  methods: {
    ...mapActions([actionTypes.GET_PROFILE])
  },
  mounted() {
    if (!this.profileLoaded) {
      this[actionTypes.GET_PROFILE]();
    }
  }
};
</script>
